import React from 'react'
import './loader.css'

const Loading = () => {
  return (
    <div className='loader-container'>
      <span className="loader"></span>
    </div>
  )
}

export default Loading